import React from 'react';

function Manager() {
    return (
        <div className="container">
            <br></br>
            <div className="container">
                <div className="row row-header">
                    <div className="col-12">
                        <h1>Manager</h1>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Manager;
